var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CompButton',{attrs:{"placeholder":"选择店铺","format":"{0}个店铺","value":_vm.value.id ? 1 : 0,"view-btn":false},on:{"click":_vm.handleClickAdd,"remove":_vm.onRemove}})
}
var staticRenderFns = []

export { render, staticRenderFns }